module.exports = __webpack_public_path__ + "img/4.30530e77.jpg";